export const atomicMasses = {
  X: 1.0,
  H: 1.008,
  He: 4.002602,
  Li: 6.94,
  Be: 9.0121831,
  B: 10.81,
  C: 12.011,
  N: 14.007,
  O: 15.999,
  F: 18.998403163,
  Ne: 20.1797,
  Na: 22.98976928,
  Mg: 24.305,
  Al: 26.9815385,
  Si: 28.085,
  P: 30.973761998,
  S: 32.06,
  Cl: 35.45,
  Ar: 39.948,
  K: 39.0983,
  Ca: 40.078,
  Sc: 44.955908,
  Ti: 47.867,
  V: 50.9415,
  Cr: 51.9961,
  Mn: 54.938044,
  Fe: 55.845,
  Co: 58.933194,
  Ni: 58.6934,
  Cu: 63.546,
  Zn: 65.38,
  Ga: 69.723,
  Ge: 72.63,
  As: 74.921595,
  Se: 78.971,
  Br: 79.904,
  Kr: 83.798,
  Rb: 85.4678,
  Sr: 87.62,
  Y: 88.90584,
  Zr: 91.224,
  Nb: 92.90637,
  Mo: 95.95,
  Tc: 97.90721,
  Ru: 101.07,
  Rh: 102.9055,
  Pd: 106.42,
  Ag: 107.8682,
  Cd: 112.414,
  In: 114.818,
  Sn: 118.71,
  Sb: 121.76,
  Te: 127.6,
  I: 126.90447,
  Xe: 131.293,
  Cs: 132.90545196,
  Ba: 137.327,
  La: 138.90547,
  Ce: 140.116,
  Pr: 140.90766,
  Nd: 144.242,
  Pm: 144.91276,
  Sm: 150.36,
  Eu: 151.964,
  Gd: 157.25,
  Tb: 158.92535,
  Dy: 162.5,
  Ho: 164.93033,
  Er: 167.259,
  Tm: 168.93422,
  Yb: 173.054,
  Lu: 174.9668,
  Hf: 178.49,
  Ta: 180.94788,
  W: 183.84,
  Re: 186.207,
  Os: 190.23,
  Ir: 192.217,
  Pt: 195.084,
  Au: 196.966569,
  Hg: 200.592,
  Tl: 204.38,
  Pb: 207.2,
  Bi: 208.9804,
  Po: 208.98243,
  At: 209.98715,
  Rn: 222.01758,
  Fr: 223.01974,
  Ra: 226.02541,
  Ac: 227.02775,
  Th: 232.0377,
  Pa: 231.03588,
  U: 238.02891,
  Np: 237.04817,
  Pu: 244.06421,
  Am: 243.06138,
  Cm: 247.07035,
  Bk: 247.07031,
  Cf: 251.07959,
  Es: 252.083,
  Fm: 257.09511,
  Md: 258.09843,
  No: 259.101,
  Lr: 262.11,
  Rf: 267.122,
  Db: 268.126,
  Sg: 271.134,
  Bh: 270.133,
  Hs: 269.1338,
  Mt: 278.156,
  Ds: 281.165,
  Rg: 281.166,
  Cn: 285.177,
  Nh: 286.182,
  Fl: 289.19,
  Mc: 289.194,
  Lv: 293.204,
  Ts: 293.208,
  Og: 294.214,
};
